import type { Editor } from 'slate'
import type { CustomEditor } from 'modules/community/types/custom-editor'

// TODO: inline
const withLinks = (editor: Editor): CustomEditor => {
  const { isInline } = editor
  editor.isInline = element => (element.type === 'link' ? true : isInline(element))
  return editor
}

export default withLinks
